import * as _ from 'lodash';
import { TAction } from '../actions/types/action';
import { TRecruitmentSettingsState } from '../libs/store';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  profileId: -1
};

const DELETE_PROFILE = 'RECRUITMENT/SETTINGS/DELETE';
const DELETE_PROFILE_SUCCESS = 'RECRUITMENT/SETTINGS/DELETE_SUCCESS';
const DELETE_PROFILE_FAIL = 'RECRUITMENT/SETTINGS/DELETE_FAIL';
const deleteProfile = (profileId: number) => ({
  type: DELETE_PROFILE,
  payload: {
    profileId,
    loading: true
  }
});
const deleteProfileSuccess = (profileId: number) => ({
  type: DELETE_PROFILE_SUCCESS,
  payload: {
    ...initialState,
    loaded: true
  }
});
const deleteProfileFail = () => ({
  type: DELETE_PROFILE_FAIL,
  payload: initialState
});
const UPDATE_PROFILE_STATUS = 'RECRUITMENT/SETTINGS/CHANGE_PROFILE_STATUS';
const UPDATE_PROFILE_STATUS_SUCCESS = 'RECRUITMENT/SETTINGS/CHANGE_PROFILE_STATUS_SUCCESS';
const UPDATE_PROFILE_STATUS_FAIL = 'RECRUITMENT/SETTINGS/CHANGE_PROFILE_STATUS_SUCCESS';
const updateProfileStatus = (statusType: string, profileId: number) => ({
  type: UPDATE_PROFILE_STATUS,
  payload: {
    ...initialState,
    statusType,
    profileId,
    loading: true
  }
});
const changeProfileStatusSuccess = () => ({
  type: UPDATE_PROFILE_STATUS_SUCCESS,
  payload: {
    ...initialState,
    loaded: true
  }
});
const changeProfileStatusFail = () => ({
  type: UPDATE_PROFILE_STATUS_FAIL,
  payload: {
    loaded: true,
    error: true,
    loading: false
  }
});
function recruitmentSettingsReducer(state: Partial<TRecruitmentSettingsState> = initialState, action: TAction<any>) {
  switch (action.type) {
    case UPDATE_PROFILE_STATUS:
    case UPDATE_PROFILE_STATUS_SUCCESS:
    case UPDATE_PROFILE_STATUS_FAIL:
    case DELETE_PROFILE_FAIL:
    case DELETE_PROFILE_SUCCESS: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
}

export const actionTypes = {
  DELETE_PROFILE,
  UPDATE_PROFILE_STATUS
};

export const actions = {
  deleteProfile,
  deleteProfileSuccess,
  deleteProfileFail,
  updateProfileStatus,
  changeProfileStatusSuccess,
  changeProfileStatusFail
};

export default recruitmentSettingsReducer;
